// API Configuration
export const API_BASE_URL = 'https://offapi.tattvasphere.com';

// Helper function to create full API URLs
export const createApiUrl = (endpoint: string): string => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL}/${cleanEndpoint}`;
};

// Common API request function with error handling
export const apiRequest = async (
  endpoint: string, 
  options: RequestInit = {}
): Promise<Response> => {
  const url = createApiUrl(endpoint);
  
  // Default headers
  const defaultHeaders = {
    'Content-Type': 'application/json',
  };

  // Merge headers
  const headers = {
    ...defaultHeaders,
    ...options.headers,
  };

  try {
    const response = await fetch(url, {
      ...options,
      headers,
    });

    return response;
  } catch (error) {
    console.error('API Request failed:', error);
    throw error;
  }
};

// Helper functions for common HTTP methods
export const apiGet = (endpoint: string, headers?: Record<string, string>) => 
  apiRequest(endpoint, { method: 'GET', headers });

export const apiPost = (endpoint: string, data?: any, headers?: Record<string, string>) => 
  apiRequest(endpoint, { 
    method: 'POST', 
    headers,
    body: data ? JSON.stringify(data) : undefined 
  });

export const apiPut = (endpoint: string, data?: any, headers?: Record<string, string>) => 
  apiRequest(endpoint, { 
    method: 'PUT', 
    headers,
    body: data ? JSON.stringify(data) : undefined 
  });

export const apiPatch = (endpoint: string, data?: any, headers?: Record<string, string>) => 
  apiRequest(endpoint, { 
    method: 'PATCH', 
    headers,
    body: data ? JSON.stringify(data) : undefined 
  });

export const apiDelete = (endpoint: string, headers?: Record<string, string>) => 
  apiRequest(endpoint, { method: 'DELETE', headers }); 